export default __webpack_public_path__ + "static/media/whychooseus.d434c6cb.jpg";